import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import "./uploadFilesHelpTooltip.scss";

export const UPLOAD_FILES_HELP_TEXT =
  "Click on Add Folder to create a folder and upload files.";

export default function UploadFilesHelpTooltip({
  children,
  title = UPLOAD_FILES_HELP_TEXT,
}) {
  return (
    <Tooltip
      title={title}
      arrow
      placement="top"
      enterDelay={200}
      classes={{ tooltip: "upload-files-help-tooltip" }}
    >
      <span style={{ display: "inline-flex" }}>{children}</span>
    </Tooltip>
  );
}
